import { Typography } from "@mui/material";
// Terms and conditions page.
const TermsOfUse = () => {
  return (
    <Typography component="h3" variant="h4">
      Terms And Conditions
    </Typography>
  );
};

export default TermsOfUse;
